import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=50819172"
import script from "./CommonCard.vue?vue&type=script&lang=js"
export * from "./CommonCard.vue?vue&type=script&lang=js"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=50819172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports